const menuItems = (state = [], action) => {
  switch (action.type) {
    default:
      return state;
  }
};


export { menuItems as default };



// WEBPACK FOOTER //
// ./src/reducers/menuItems.js